"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractModalBodyStatus = ContractModalBodyStatus;
exports.MilestoneModalBodyStatus = MilestoneModalBodyStatus;
const react_1 = __importStar(require("react"));
const FormContext_1 = require("../../../View/Modals/FormContext");
const StatusSelectors_1 = require("../../../View/Modals/CommonFormComponents/StatusSelectors");
function ContractModalBodyStatus({ initialData }) {
    const { setValue } = (0, FormContext_1.useFormContext)();
    console.log("initialData", initialData);
    (0, react_1.useEffect)(() => {
        setValue("_milestone._contract.status", initialData?._milestone?._contract?.status || "", {
            shouldValidate: true,
        });
    }, [initialData, setValue]);
    return react_1.default.createElement(StatusSelectors_1.ContractStatusSelector, { name: "_milestone._contract.status", label: "Status kontraktu" });
}
function MilestoneModalBodyStatus({ initialData }) {
    const { setValue } = (0, FormContext_1.useFormContext)();
    console.log("initialData", initialData);
    (0, react_1.useEffect)(() => {
        setValue("_milestone.status", initialData?._milestone?.status || "", { shouldValidate: true });
    }, [initialData, setValue]);
    return react_1.default.createElement(StatusSelectors_1.MilestoneStatusSelector, { name: "_milestone.status" });
}
